import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { AgentsService } from 'src/app/core/services/agents/agents.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { StudentInterviewService } from 'src/app/core/services/student-interview/student-interview.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';

@Component({
  selector: 'app-update-fine-popup',
  templateUrl: './update-fine-popup.component.html',
  styleUrls: ['./update-fine-popup.component.scss']
})
export class UpdateFinePopupComponent {
  comment_form:FormGroup
  private _unsubscribeAll: Subject<any> = new Subject()
    constructor(
          public dialogRef: MatDialogRef<UpdateFinePopupComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any,
          private _loaderService: LoaderService,
          private _fb: FormBuilder,
          private _studentInterviewService:StudentInterviewService,
          private _toasterService: ToasterService,
          private _agentsService: AgentsService,
          
        ) { }
  
       ngOnInit(): void {
        this.initForm();
        // console.log(this.data);
       } 
       initForm(){
        this.comment_form = this._fb.group({
          textCommend:['']
        })
       }
       updatedFineList(){
        const payload ={
          fineId:this.data?.msgId,
          comment:this.comment_form.value.textCommend,
          status:this.data?.status
        }
        this._loaderService.showLoader();
        this._agentsService.updateFineAmount(payload,this.data?.agentID)
            .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((res) => {
                this._loaderService.hideLoader();
                this.dialogRef.close(true);                
      });
    }

    close(){
      this.dialogRef.close(false);
      }          
  
}
